import { BetQLSportItem } from "./";
import { DEFAULT_TREND_TYPES } from "./configs";

const NCAAFConfig: BetQLSportItem = {
  id: "f97d5b5f-5afd-4897-8fa1-efac592c9c96",
  name: "NCAAF",
  url: "ncaaf",
  tabName: "NCAAF",
  icon: "football",
  imagePath: "NCAA",
  key: "CFB",
  lookupKey: "ncaaf",
  favoriteLine: "spread",
  hasFGspreadPowerRating: true,
  hasTeamPowerProjectionGrades: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: true,
  has1HmoneylinePowerRating: true,
  has1HtotalPowerRating: true,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: false,
  hasInjuries: false,
  hasNews: true,
  hasLineup: false,
  hasSchedule: true,
  hasConfiguredSchedule: true,
  hasTeamSummary: true,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: true,
  hasConferenceDropdown: true,
  hasNewsInjuriesColumn: false,
  hasDraws: false,
  hasSharpData: true,
  hasTopTrendsData: true,
  hasPlayerProps: false,
  hasRecommendedBets: true,
  hasPopularEvents: true,
  isCollege: true,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,5,9,15,4]}',
  defaultColumnOrder: [2, 5, 9, 15, 4],
  publicThreshold: 60,
  sharpPercentThreshold: 20,
  sharpCountThreshold: 500,
  publicCountThreshold: 500,
  trendTypes: DEFAULT_TREND_TYPES,
  filters: [
    {
      name: "Spread",
      key: "spread",
      url: "spread",
    },
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline",
    },
    {
      name: "Total",
      key: "total",
      url: "totals-spread",
    },
    {
      name: "1st Half Spread",
      key: "1Hspread",
      url: "first-half-lines",
    },
    {
      name: "1st Half Moneyline",
      key: "1Hmoneyline",
      url: "first-half-moneyline",
    },
    {
      name: "1st Half Total",
      key: "1Htotal",
      url: "first-half-totals-spread",
    },
    {
      name: "2nd Half Spread",
      key: "2Hspread",
      url: "second-half-lines",
    },
    {
      name: "2nd Half Moneyline",
      key: "2Hmoneyline",
      url: "second-half-moneylines",
    },
  ],
  periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
  periodKeys: ["FG", "1H", "2H"],
  pickTypes: ["spread", "moneyline", "total", "1Hspread", "1Hmoneyline", "1Htotal", "2Hspread", "2Hmoneyline"],
  conferenceList: [
    {
      name: "All Conferences",
      key: "ALL",
      url: "all",
    },
    {
      name: "Top 25",
      key: "TOP25",
      url: "top-25",
    },
    {
      name: "American Athletic",
      key: "AAC",
      url: "american-athletic",
    },
    {
      name: "Atlantic Coast",
      key: "ACC",
      url: "atlantic-coast",
    },
    {
      name: "Big 12",
      key: "B12",
      url: "big-12",
    },
    {
      name: "Big Ten",
      key: "B1G",
      url: "big-ten",
    },
    {
      name: "Conference USA",
      key: "CUSA",
      url: "conference-usa",
    },
    {
      name: "FBS Independents",
      key: "IND",
      url: "fbs-independents",
    },
    {
      name: "Mid-American",
      key: "MAC",
      url: "mid-american",
    },
    {
      name: "Mountain West",
      key: "MWC",
      url: "mountain-west",
    },
    {
      name: "Pac-12",
      key: "P12",
      url: "pac-12",
    },
    {
      name: "SEC",
      key: "SEC",
      url: "sec",
    },
    {
      name: "Sun Belt",
      key: "SBC",
      url: "sun-belt",
    },
  ],
};

export default NCAAFConfig;
